const contentful = require("contentful");
export const client = contentful.createClient({
  // This is the space ID. A space is like a project folder in Contentful terms
  space: "x77xlx3zz09d",
  // This is the access token for this space. Normally you get both ID and the token in the Contentful web app
  accessToken: "Z-FvSCjat6bORiLthiM0S2ZbFQz0g8oulVtNBEOvyEk"
});